import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class TeamsMultiSelectListComponent implements IController {
  selectedIds: any;
  optionIds: any;
  excludeIds: any;
  onChange: Function;

  private teamsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  private excludeKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $log, private $teams, private $infiniteScroll, private commonsService: CommonsService) {
  }

  $onInit() {
    this.teamsRef = this.$teams();
    this.loadLimit = 20;

    this.teamsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.teamsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  onToggle(teamId, isSelected) {
    this.onChange({
      teamIds: isSelected ? _.concat(this.selectedIds || [], [teamId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== teamId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.optionIds) {
      this._reload();
    } else {
      this._search();
    }
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({teamIds: []});
    } else {
      this.onChange({teamIds: this.infiniteScroll?.getItems()?.map((team) => team.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(team => team.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.teamsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }


  private _search() {
    this.infiniteScroll.search(this.queryString);
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      ids: this.optionIds,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.teams')
  .component('teamsMultiSelectList', {
    bindings: {
      selectedIds: '<',
      optionIds: '<?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./teams-multi-select-list.html').default,
    controller: TeamsMultiSelectListComponent
  });
